export default class extends Controller {
  static targets = ['select'];

  connect() {
    App.DynamicSelect.initEl(this.selectTarget);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/dynamic-select-controller.js